<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Batch Report
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container report-container">
                <div style="width: 100%">
                    <ppl-report-filters (filterChanged)="filterChanged($event)" [filterFields]="filterFields" [report]="'batchReport'"
                    [batchDates]="batchDates"></ppl-report-filters>
                </div>
                <div class="chart-wrapper">
                    <nz-card id="chart">
                        @if(chartOptions){
                        <nz-checkbox-group style="margin-bottom: 8px;" [(ngModel)]="selectedFilters"
                            (ngModelChange)="onCheckboxChange($event)">
                        </nz-checkbox-group>
                        <!-- <div class="chart-summary" *ngIf="chartTotals?.length">
                            <div *ngFor="let line of chartTotals">{{ line }}</div>
                        </div> -->
                        <apx-chart id='batchReport' [series]="chartOptions.series" [chart]="chartOptions.chart"
                            [dataLabels]="chartOptions.dataLabels" [title]="chartOptions.title" [plotOptions]="chartOptions.plotOptions"
                            [yaxis]="chartOptions.yaxis" [legend]="chartOptions.legend" [fill]="chartOptions.fill"
                            [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip" [subtitle]="chartOptions.subtitle"
                            [xaxis]="chartOptions.xaxis"></apx-chart>
                        }
                    </nz-card>
                </div>
                @if (batchReportData) {
                    <div style="min-width: 50%;">
                        <ppl-list-table [disableSort]="true" [pageConfig]="programName" [disableSearch]="true"
                        [showCustomSearch]="false" [data]="formattedBatchReportData" [disableSelection]="true" [cols]="visibleColumns"
                        [gridTitle]="false" [pagination]="true" [loadPage]="false" [enableActions]="false"
                        [customDataLoaded]="true">
                    </ppl-list-table>
                    </div>
                }
            </div>
        </div>
    </div>
</ng-container>